import { request } from '@/common/services/request';

export { queryOperationAnalysisSubjects } from '@/common/services/operation-analysis-scope';

export const queryOperationFactDashboard = ({
  current,
  endDate,
  organizationId,
  pageSize,
  scope,
  sortField,
  sortOrder,
  startDate,
}) =>
  request('/api/operations/tenant/fact-dashboard', {
    data: { current, endDate, pageSize, scope, sortField, sortOrder, startDate },
    method: 'POST',
    params: { organizationId },
  });
